<template>
  <div>
    <v-container style="padding: 0">
      <v-card flat>
        <v-col>
          <div
            class="text-h4 px-2 pt-10 text--center block font-weight-light"
            style="color: #B56476"
          >
            <p class="text-center">CONTACT &amp; ADDRESSES</p>
            <v-divider inset></v-divider>
          </div>
        </v-col>

        <v-row>
          <v-col cols="5 offset-sm-1">
            <v-sheet class="mx-6 blue-grey--text mb-15">
              <v-card class="mx-auto" flat>
                <v-card-title> Manjo Travel Office </v-card-title>
                <v-card-text
                  >Jl. Arnold Mononutu, Airmadidi Atas Link 9. Airmadidi,
                  Minahasa Utara, Sulawesi Utara Indonesia, 95371</v-card-text
                >
                <div>
                  <v-list two-line>
                    <v-list-item v-for="c in contacts" :key="c.subtitle">
                      <!-- <v-list-item-icon>
                      <v-icon color="#F0807F">
                        {{ c.icon }}
                      </v-icon>
                    </v-list-item-icon> -->
                      <v-avatar color="#F0807F" size="40">
                        <v-icon color="white">
                          {{ c.icon }}
                        </v-icon>
                      </v-avatar>

                      <v-list-item-content class="ml-2">
                        <v-list-item-title>{{ c.title }}</v-list-item-title>
                        <v-list-item-subtitle>{{
                          c.subtitle
                        }}</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </div>
              </v-card>
            </v-sheet>
          </v-col>
          <v-col cols="5">
            <v-sheet class="mx-6 blue-grey--text mb-15">
              <v-card class="mx-auto" flat>
                <v-card-title> Garuda Sales Outlet Office </v-card-title>
                <v-card-subtitle>(Gerai Garuda Indonesia)</v-card-subtitle>
                <v-card-text
                  >Ground Floor Azalea Building Jl. Arnold Mononutu, Airmadidi
                  Atas Link 9, Airmadidi, Minahasa Utara, Sulawesi
                  Utara</v-card-text
                >
                <div>
                  <v-list two-line>
                    <v-list-item v-for="c in contacts" :key="c.subtitle">
                      <!-- <v-list-item-icon>
                      <v-icon color="#F0807F">
                        {{ c.icon }}
                      </v-icon>
                    </v-list-item-icon> -->
                      <v-avatar color="#F0807F" size="40">
                        <v-icon color="white">
                          {{ c.icon }}
                        </v-icon>
                      </v-avatar>

                      <v-list-item-content class="ml-2">
                        <v-list-item-title>{{ c.title }}</v-list-item-title>
                        <v-list-item-subtitle>{{
                          c.subtitle
                        }}</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </div>
              </v-card>
            </v-sheet>
          </v-col>
          <v-col cols="12">
            <v-card max-width="400" class="mx-auto mb-5">
              <v-card-text>
                <v-card-title>KEY CONTACT</v-card-title>
                <v-row>
                  <v-col cols="4">
                    <v-avatar size="96" class="mr-4 border">
                      <img
                        src="https://scontent-cgk1-1.xx.fbcdn.net/v/t1.0-9/4826_96887308921_7165073_n.jpg?_nc_cat=107&ccb=2&_nc_sid=de6eea&_nc_eui2=AeFkVERks96eynxGYx-E_tkQ0gHGWpFUznDSAcZakVTOcIeiTsJUnfaL9LBQwSbmKMg3W2m3eeduLPFgmuPJTjhn&_nc_ohc=xU476F6t0zQAX_RGRRj&_nc_oc=AQnKzesAwMg7RilHKdWn3GXs7y6DBUYpVT_NkSCOKY2HtOBLi8_Yqg66uKrjGrYbCu0&_nc_ht=scontent-cgk1-1.xx&oh=f518dba47adada83368feadf09424f83&oe=5FDA725D"
                        alt="G"
                      />
                    </v-avatar>
                  </v-col>
                  <v-col>
                    <div class="text-h5">Grace Lumowa</div>
                    <p>Managing Director</p>
                    <div>
                      <v-avatar color="#F0807F" size="20">
                        <v-icon color="white" x-small>
                         mdi-cellphone
                        </v-icon>
                      </v-avatar>
                      <span class="ml-2 text-headline">+62 812 449 202 58</span>
                    </div>
                    <div>
                      <v-avatar color="#F0807F" size="20">
                        <v-icon color="white" x-small>
                         mdi-email
                        </v-icon>
                      </v-avatar>
                      <span class="ml-2 text-headline">grace@manjotravel.com</span>
                    </div>                    
                  </v-col>

                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-card>
    </v-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      gerai: [
        {
          icon: "mdi-phone",
          title: "+62.431-894-1317",
          subtitle: "Office Phone",
        },
        {
          icon: "mdi-cellphone-basic",
          title: "+62.853-436-26622",
          subtitle: "Garuda Outlet Hotline / Whatsapp",
        },
        {
          icon: "mdi-at",
          title: "booking@manjotravel.com",
          subtitle: "Email",
        },
      ],
      contacts: [
        {
          icon: "mdi-phone",
          title: "+62.431-894-1317",
          subtitle: "Office Phone",
        },
        {
          icon: "mdi-cellphone-basic",
          title: "+62.853-436-26688",
          subtitle: "Hotline / Whatsapp",
        },
        {
          icon: "mdi-at",
          title: "garudaoutlet@manjotravel.com",
          subtitle: "Email",
        },
      ],
    };
  },
};
</script>

<style></style>
